import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
export default {
  props: ["param"],
  data: function data() {
    return {
      updateParam: this.param
    };
  },
  methods: {
    addOption: function addOption() {
      var lastValue = 0;
      this.updateParam.option.forEach(function (val) {
        if (val.value > lastValue) {
          lastValue = val.value;
        }
      });
      var nextValue = parseInt(lastValue) + 1;
      this.updateParam.option.push({
        label: "选项" + nextValue,
        value: nextValue
      });
    },
    removeOption: function removeOption(index) {
      this.updateParam.option.splice(index, 1);
    }
  },
  watch: {
    param: function param(val) {
      this.updateParam = val;
    }
  }
};